module.exports = __webpack_public_path__ + "static/media/odonto.368ef119.png";